import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from "react-elastic-carousel";
import React from 'react';
import styles from './slider.module.css';
import useTranslation from "next-translate/useTranslation";

var Slider = function Slider(_ref) {
  var setting = _ref.setting;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var breakPoints = [//from the breakpoint and up it will effect
  {
    width: 340,
    itemsToShow: 1
  }, {
    width: 590,
    itemsToShow: 2
  }, {
    width: 890,
    itemsToShow: 3
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "score-slider position-relative ".concat(setting.className),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.carousel,
        children: [/*#__PURE__*/_jsx("h3", {
          className: styles.badgesText,
          children: t('score:badges')
        }), /*#__PURE__*/_jsx(Carousel, {
          enableAutoPlay: true,
          autoPlaySpeed: 3200,
          breakPoints: breakPoints,
          children: setting.items.map(function (item, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: "".concat(styles.wrapper),
              children: [/*#__PURE__*/_jsx("img", {
                src: item.image
              }), /*#__PURE__*/_jsx("p", {
                className: styles.badgeName,
                style: {
                  color: "".concat(setting.colors[index])
                },
                children: item.title
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: /*#__PURE__*/_jsx("p", {
                  children: setting.descriptions[index]
                })
              })]
            }, index);
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.badges,
        children: [/*#__PURE__*/_jsx("h3", {
          className: styles.badgesText,
          children: t('score:badges')
        }), /*#__PURE__*/_jsx("div", {
          children: setting.items.map(function (item, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: "".concat(styles.wrapper),
              children: [/*#__PURE__*/_jsx("img", {
                src: item.image
              }), /*#__PURE__*/_jsx("p", {
                className: styles.badgeName,
                style: {
                  color: "".concat(setting.colors[index])
                },
                children: item.title
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: /*#__PURE__*/_jsx("p", {
                  children: setting.descriptions[index]
                })
              })]
            }, index);
          })
        })]
      })]
    })
  });
};

export default Slider;